import { getDurationBetweenDates } from 'utils/DateHelper';
import debounce from 'lodash.debounce';
import { mapGetters } from 'vuex';
import { searchAllFilterNames } from 'router/guards/queryConfig';
// get some location data for GTM Tracking
export default {
  computed: {
    resultCount() { return this.$store.state.searchTotalObjects; }, // (Anzahl Suchtreffer)
    resultOrder() { return this.$store.state.searchFilter.sort || ''; }, // (Sortierung)
    CountryISO() { return (this.$route.query.country || this.$store.state.locationInformations?.locationCountryCode) || ''; }, // (ISO des gesuchten Landes)
    CountryName() { // (Name des gesuchten Landes)
      return this.$store.state.locationInformations.locationParentCountryName || this.$store.state.locationInformations.locationName;
    },
    Region1() { // ("Ober Ober Region")
      const defaultObject = {
        id: null,
        name: null,
      };
      if (!this.regions.length) {
        return defaultObject;
      }
      const region = this.regions[0];
      return {
        id: region.regionID,
        name: region.name,
      };
    },
    Region2() { // ("Ober Region")
      const defaultObject = {
        id: null,
        name: null,
      };
      if (this.regions.length < 2) {
        return defaultObject;
      }
      const region = this.regions[1];
      return {
        id: region.regionID,
        name: region.name,
      };
    },
    Region3() { // ("unter unter Region")
      const defaultObject = {
        id: null,
        name: null,
      };
      if (this.regions.length < 3) {
        return defaultObject;
      }
      const region3 = this.regions[2];
      return {
        id: region3.regionID,
        name: region3.name,
      };
    },

    regions() {
      const breadCrumb = this.getLocationBreadcrumbs();
      // console.log('breadCrumb', breadCrumb);
      const regions = breadCrumb.filter((item) => item.regionID); // find locations with regionid

      return regions || [];
    },

    PlaceID() { // (ID des gesuchten Orts)
      if (this.$store.state.locationInformations.locationType !== 3) {
        return null;
      }
      return this.$store.state.locationInformations.locationNumber || null;
    },
    PlaceName() { // (Name des gesuchten Orts)
      if (this.$store.state.locationInformations.locationType !== 3) {
        return null;
      }
      return this.$store.state.locationInformations.locationName;
    },
    Pattern() {
      if (this.$route.query.fulltext) { return `freitext=${this.$route.query.fulltext}`; }
      // if (this.$route.query.q) { return `q=${this.$route.query.q}`; }
      return null;
    }, // (freitext; z.B. "/Suche?fulltext=dreieich" oder "q=Österreich")
    withPets() { // (wenn nach:'',//(mehrere) Haustier(e) erlaubt gesucht wurde, dann = 1)
      const petvalue = {
        any: 0,
        none: -1,
        one: 1,
        more: 1,
      };
      const idx = (this.$store.getters.getSearchFilter('pets') || false) ? this.$store.getters.getSearchFilter('pets') : 'any';
      return petvalue[idx];
    },
    withPool() { return (this.$store.getters.getSearchFilter('swimmingpool') === 'Y') ? 1 : 0; }, // (wenn nach pool gesucht wurde, dann = 1)
    personsMax() {
      // persons
      return this.$store.getters.getSearchFilter('persons') || 2;
    }, // (Anzahl mögliche Personen)
    searchObjects() {
      return this.$store.getters.getSearchObjects || [];
    },
    topObject1() { return this.searchObjects[0]?.objectNumber || null; }, // (1. Suchtreffer)
    topObject2() { return this.searchObjects[1]?.objectNumber || null; }, // (2. Suchtreffer)
    topObject3() { return this.searchObjects[2]?.objectNumber || null; }, // (3. Suchtreffer)
    searchDuration() {
      if (this.$route.query.startDate && this.$route.query.endDate) {
        return getDurationBetweenDates(this.$route.query.startDate, this.$route.query.endDate);
      }
      if (this.$route.query.startDate && !this.$route.query.endDate) {
        return 7;
      }
      return null;
    },
    seaside() {
      return this.$store.getters.getSearchFilter('distSea') || null;
    },
    lakeside() {
      return this.$store.getters.getSearchFilter('distLake') || null;
    },

    queryObject() {
      return this.$router.currentRoute.query.toString();
    },
    searchStartDate() {
      return this.$route.query.startDate || null;
    },
    searchEndDate() {
      return this.$route.query.endDate || null;
    },
  },
  data() {
    return {
      searchTrackData: {
        resultCount: '',
        resultOrder: '',
        CountryISO: '',
        CountryName: '',
        Region1ID: '',
        Region1Name: '',
        Region2ID: '',
        Region2Name: '',
        Region3ID: '',
        Region3Name: '',
        PlaceID: '',
        PlaceName: '',
        Pattern: '',
        searchStartDate: '',
        searchEndDate: ''
      },
      delay: false,
      resultDataReady: false,
      locationDataReady: false,
      trackingDataReady: false,
    };
  },
  watch: {
    resultCount: {
      immediate: true,
      handler: 'setTrackData',
    },
    resultOrder(newOrder) {
      this.searchTrackData.resultOrder = newOrder;
      this.searchTrack();
    },
    CountryName: {
      immediate: true,
      handler: 'setLocationData',
    },
    Region1: {
      immediate: true,
      handler: 'setLocationData',
    },
    Region2: {
      immediate: true,
      handler: 'setLocationData',
    },
    Region3: {
      immediate: true,
      handler: 'setLocationData',
    },
    PlaceID: {
      immediate: true,
      handler: 'setLocationData',
    },
    CountryISO: {
      immediate: true,
      handler: 'isoSet',
    },
    $route: [{ // watch route change
      immediate: true,
      handler: 'econdaPush',
    }],

  },
  methods: {
    ...mapGetters(['getLocationBreadcrumbs']),
    isoSet(newIsoCode) {
      this.searchTrackData.CountryISO = newIsoCode;
    },
    setLocationData() {
      this.searchTrackData.CountryName = this.CountryName;
      this.searchTrackData.Region1ID = this.Region1.id;
      this.searchTrackData.Region1Name = this.Region1.name;
      this.searchTrackData.Region2ID = this.Region2.id;
      this.searchTrackData.Region2Name = this.Region2.name;
      this.searchTrackData.Region3ID = this.Region3.id;
      this.searchTrackData.Region3Name = this.Region3.name;
      this.searchTrackData.PlaceID = this.PlaceID;
      this.searchTrackData.PlaceName = this.PlaceName;
      debounce(() => {
        // console.log('call searchTrack after debounce');
        this.searchTrack();
        this.locationDataReady = Promise.resolve(true);
      }, 1000);
    },

    setTrackData(newCount) {
      this.searchTrackData.resultCount = newCount;
      this.searchTrackData.resultOrder = this.resultOrder;
      this.searchTrackData.Pattern = this.Pattern;
      this.searchTrackData.pets = this.withPets;
      this.searchTrackData.pool = this.withPool;
      this.searchTrackData.distSea = this.seaside;
      this.searchTrackData.distLake = this.lakeside;
      this.searchTrackData.topObject1 = this.topObject1;
      this.searchTrackData.topObject2 = this.topObject2;
      this.searchTrackData.topObject3 = this.topObject3;
      this.searchTrackData.duration = this.searchDuration;
      this.searchTrackData.searchStartDate = this.searchStartDate;
      this.searchTrackData.searchEndDate = this.searchEndDate;
      this.searchTrack();
      this.trackingDataReady = Promise.resolve(true);
    },
    searchTrack() {
      // make sure all datalayer data and userdata is pushed, before firing dataLayerReady
      Promise.all([this.locationDataReady, this.trackingDataReady])
        .then(() => {
          // console.log('searchTrack Promise All Resolved');
          if (this.delay !== false) {
            clearTimeout(this.delay);
          }
          this.delay = setTimeout(() => { // debounce multiple pushes
            this.dataLayerPush(this.searchTrackData);
            // this.dataLayerPush(this.searchquery);
            // this.econdaPush();
            this.delay = false;
            // set data.dataLayerReady in Search.vue to trigger dataLayer push
            this.dataLayerReady = true;
          }, 2000);
        })
        .catch((reason) => {
          // eslint-disable-next-line no-console
          console.log('searchTrackData Promise Error', reason);
        });
    },
    // get allowed values and build url for econda tracking
    econdaPush() {
      const args = this.$router.currentRoute.query;
      let trackData = {};
      const queryPairs = Object.entries(args); // get array from search query
      if (typeof URLSearchParams !== 'undefined') {
        const params = new URLSearchParams();
        queryPairs.forEach(([key, val]) => { // check if key is in allowed filternames
          if (searchAllFilterNames.indexOf(key) > -1) { params.append(key, val); }
        });
        let queryString = '';
        queryString += params.toString();

        const path = `${this.$router.currentRoute.path}`;

        let url = path + ((queryString.length) ? '?' : '');
        url += queryString;
        trackData = {
          event: 'EcondaSuchePush',
          EcondaSuche: url,
        };
        this.dataLayerPush(trackData);
      }
    },
  },
};
